var module = angular.module('octopusApp.projects');

module.directive('singleValueAdder', function($timeout, octopusLog) {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/actions/docker_network/single-value-adder.html',
        require: 'ngModel',
        scope: {
            action: '=',
            project: '=',
            localNames: '=',
            placeholder: '@',
            helptext: '@'
        },
        link: function($scope, $element, attrs, ngModel) {

            $scope.vm.valuesUpdated = function valuesUpdated() {
                ngModel.$setViewValue($scope.vm.items.map(function(c){ return c.name; }).join(','));
            };

            ngModel.$render = function onRender() {
                if (ngModel.$viewValue) {
                    $scope.vm.items = ngModel.$viewValue.split(',')
                        .map(function (v) {
                            return v.trim();
                        })
                        .filter(function (v) {
                            return !!v && v !== '';
                        })
                        .map(function (v) {
                            return {name: v, editName: v};
                        });
                }
            };
        },
        controller: function() {
            var vm = this;

            vm.newContainer = "";
            vm.editContainer = "";
            vm.addContainer = addContainer;
            vm.cancelEdit = cancelEdit;
            vm.commitEdit = commitEdit;
            vm.remove = remove;
            vm.items = [];
            vm.isEditing = false;

            function addContainer() {
                if (vm.items.indexOf(vm.newContainer) !== -1) {
                    octopusLog.log("That address range is already covered by an existing selection.. Try again");
                    return;
                }

                vm.items.push({name: vm.newContainer, editName:  vm.newContainer});
                vm.valuesUpdated();
                vm.newContainer = "";
                vm.editContainer = "";
            }

            function commitEdit(container) {
                container.isEditing = false;
                container.name = container.editName;
                vm.valuesUpdated();
            }

            function remove(container) {
                var idx = vm.items.indexOf(container);

                if (idx >= 0) {
                    vm.items.splice(idx, 1);
                }
                vm.valuesUpdated();
            }

            function cancelEdit(container) {
                container.isEditing = false;
                container.editName = container.name;
            }
        },
        controllerAs: 'vm',
        bindToController: true
    };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/docker_network/single-value-adder.js
// module id = 864567703671752
// module chunks = 1